import {sortBy} from 'lodash';
import {useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';

/**
 * Returns entire event schedule
 * @type {array}
 */
export function useEventSchedule(eventId, {filter, orderBy} = {}) {
    const selector = useCallback(state => state.events[eventId]?.schedule?.all, [eventId]),
        all = useSelector(selector) || [];

    return useMemo(() => {
        let schedule = all;

        if (filter) schedule = schedule.filter(filter);
        if (orderBy) schedule = sortBy(schedule, orderBy);

        return schedule;
    }, [all, filter, orderBy]);
}
